const AlertActions = {
    UPDATE: 'UPDATE_ALERT',
}

export default AlertActions;